module.exports = __webpack_public_path__ + "img/address.31e7a7ea.svg";